/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseValidator} from "./BaseValidator";
import {ObjectUtils} from "../../../Utils/ObjectUtils";

export class JsonValidator extends BaseValidator {
	logic(x, model, data) {
		return x === null || x === '' || ObjectUtils.IsJson(x);
	}

	message(model) {
		return "Must be valid JSON.";
	}
}
